import load from 'sdk/permission';
import { LOAD } from 'model/permission';
import { takeEvery } from 'redux-saga/effects';
import { callAction } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      type: LOAD,
    })
  );
}
